import { useState } from 'react';

export function KontaktPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    const response = await fetch('https://fojubejaymmnxqsulnql.supabase.co/functions/v1/contact-form-submission', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        message,
      }),
    });

    const result = await response.json();
    if (result.ok || !result.error) {
      setSent(true);
    }
  }

  if (sent) {
    return (
      <div className="max-w-md mx-auto py-12">
        <h1 className="text-2xl font-serif mb-4">Nachricht gesendet</h1>
        <p className="text-text-secondary">Vielen Dank fur Ihre Nachricht. Wir melden uns in Kurze bei Ihnen.</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Kontakt</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium mb-1">Name</label>
          <input id="name" className="input-field" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium mb-1">E-Mail</label>
          <input id="email" type="email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label htmlFor="message" className="block text-sm font-medium mb-1">Nachricht</label>
          <textarea id="message" className="input-field" rows={5} value={message} onChange={(e) => setMessage(e.target.value)} required />
        </div>
        <button type="submit" className="btn-primary">Nachricht senden</button>
      </form>
    </div>
  );
}
